import { LoaderFunctionArgs, Outlet } from 'react-router-dom'
import { runUserPreferencesGuard } from '@/src/router/guards/runUserPreferenceGuard'
import { userPreferencesPort } from '@/infra/config/beans'

export const Loader = ({ request }: LoaderFunctionArgs) => {
  const currentPath = new URL(request.url).pathname
  return runUserPreferencesGuard(userPreferencesPort, currentPath)
}

const Layout = () => {
  return <Outlet />
}

export default Layout
